import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {UserApiService} from '../api/user-api.service';
import {ToastrService} from 'ngx-toastr';
import {HttpClient} from '@angular/common/http';
import {PaymentApiService} from '../api/payment-api.service';
import {EmailApiService} from '../api/email-api.service';

declare var $: any;
declare var Stripe: any;

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrl: './register.component.css'
})
export class RegisterComponent {
    pageid: number = 1;


    constructor(
        private router: Router,
        private http: HttpClient,
        private userApiService: UserApiService,
        private toastr: ToastrService,
        private paymentApi: PaymentApiService,
        private emailApi: EmailApiService
    ) {
    }

    // Called when user clicks PAY NOW button
    payNow(type: 'life' | 'annual') {
        const pendingRegistration = sessionStorage.getItem('pendingRegistration');
        if (!pendingRegistration) {
            this.pageid = Number(sessionStorage.getItem('pageid'));
        }
        if (this.pageid === 1) {
            //  type = 'bizconf';
            if (!pendingRegistration) {
                this.router.navigate(['/register-form']);
                return;
            }
            // Store membership type before redirect
            sessionStorage.setItem("pendingMembershipType", type);
        }
        // The API records this on the Stripe session and checks it when confirming the payment
        const payingUser = this.pageid === 3
            ? JSON.parse(sessionStorage.getItem('profileData') || '{}')
            : JSON.parse(pendingRegistration || '{}');
        this.paymentApi.createCheckoutSession({membershipType: type, userCountry: 'USA', pageid: this.pageid, userId: payingUser?.id})
            .subscribe({
                next: (resp) => {
                    const stripe = Stripe(resp.publicKey);
                    stripe.redirectToCheckout({sessionId: resp.sessionId});
                },
                error: () => {
                    this.toastr.error("Could not start payment. Try again.");
                }
            });

    }

    selectMembership(membershipId: string) {
        const pendingRegistration = sessionStorage.getItem('pendingRegistration');
        this.pageid = Number(sessionStorage.getItem('pageid'));
        if (!pendingRegistration && this.pageid === 1) {
            this.router.navigate(['/register-form']);
            return;
        }

        if (membershipId === 'fm') {
            $('#paymentReminderModal').modal('show');
        }
    }

    completeRegistration() {

        if (this.pageid === 3) {
            $('#paymentReminderModal').modal('hide');
            sessionStorage.removeItem('pageid');
            this.router.navigate(['/profile']);
        }
        const pendingRegistration = sessionStorage.getItem('pendingRegistration')||"";
        if (!pendingRegistration  && this.pageid === 1) {
            this.router.navigate(['/register-form']);
            return;
        }


        const user = JSON.parse(pendingRegistration);

        // 📧 Send email
        this.emailApi.sendRegistrationEmail({
            name: user.firstname + ' ' + user.lastname,
            email: user.email,
            phone: user.phone,
            subject: 'New Membership Registration',
            message:

                'New Membership Registration\n'
                + `Payment: Skipped the payment option \n`

        }).subscribe();


        sessionStorage.removeItem('pendingRegistration');
        sessionStorage.removeItem('pageid');
        $('#paymentReminderModal').modal('hide');
        this.toastr.success(
            'Your profile is under review and will be activated soon!',
            'Success'
        );

        this.router.navigate(['/login']);

    }
}
